import { render, staticRenderFns } from "./MapIconInstituteModern.vue?vue&type=template&id=759bde1f&scoped=true&"
import script from "./MapIconInstituteModern.vue?vue&type=script&lang=js&"
export * from "./MapIconInstituteModern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "759bde1f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('759bde1f')) {
      api.createRecord('759bde1f', component.options)
    } else {
      api.reload('759bde1f', component.options)
    }
    module.hot.accept("./MapIconInstituteModern.vue?vue&type=template&id=759bde1f&scoped=true&", function () {
      api.rerender('759bde1f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/map/icons/MapIconInstituteModern.vue"
export default component.exports